import React from "react";
import type { FC } from "react";

import cn from "classnames";

import type { OnlineIndicatorProps } from "./types";

import classes from "./OnlineIndicator.styl";

export const ONLINE_INDICATOR_TEST_ID = "online-indicator-test-id";
const ONLINE_INDICATOR_DISPLAY_NAME = "OnlineIndicator";

/**
 *  Индикатор онлайна
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?m=auto&node-id=2-85040" target="_blank">Спека</a>
 * @constructor
 *
 * @deprecated Используйте пресеты компонента Indicator — OnlineIndicatorMob или OnlineIndicatorWeb.
 */
export const OnlineIndicator: FC<OnlineIndicatorProps> = ({
    size = "8",
    view = "mobile",
    stroke = true,
    "data-tsid": tsid,
}) => {
    const onlineIndicatorClasses = cn(
        classes["online-indicator"],
        classes[`__size-${size}`],
        classes[`__view-${view}`],
        {
            [classes["__stroke"]]: stroke,
        },
    );

    return (
        <div
            className={onlineIndicatorClasses}
            data-tsid={tsid || ONLINE_INDICATOR_TEST_ID}
            data-uikit={ONLINE_INDICATOR_DISPLAY_NAME}
        ></div>
    );
};

OnlineIndicator.displayName = ONLINE_INDICATOR_DISPLAY_NAME;

export default OnlineIndicator;
